/* fiveaven : file d'attente du panier (window.FVCart), partagée par le tiroir (fv-panier.js) et le récapitulatif (fv-recap.js).
   - toutes les écritures (/cart/add.js, change.js, update.js, clear.js) passent l'une après l'autre, jamais deux en parallèle :
     deux clics rapprochés ne se croisent plus et chaque réponse reflète l'état réel du panier ;
   - après chaque écriture réussie, UN seul événement document « fv:cart », detail = { panier, source, chemin } :
     panier = panier complet (après cart/add.js, relu dans la même file), source = qui a écrit (« fvp » tiroir, « fvr » récapitulatif) ;
     chaque composant ignore ses propres écritures (il les affiche lui-même) et se rafraîchit sur celles des autres, sans relire /cart.js ;
   - les sections Eurus (compteurs de l'en-tête) sont demandées et rafraîchies ici, sans « cart-drawer » (tiroir Eurus remplacé) ;
   - lire() : GET /cart.js, après les écritures déjà en file.
   Chargé avant fv-panier.js (snippets/fv-panier.liquid) et avant fv-recap.js (sections/fv-recap.liquid) ; un seul exemplaire actif. */
(function () {
  "use strict";
  if (window.FVCart) return;
  var RACINE = String((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/").replace(/\/?$/, "/");
  var EVENEMENT = "fv:cart", DEFAUT = "Le panier n'a pas pu être mis à jour.";
  var file = Promise.resolve();

  function store(n) { try { return window.Alpine && window.Alpine.store && window.Alpine.store(n); } catch (e) { return null; } }
  // sections Eurus rendues à chaque écriture : compteurs de l'en-tête ; « cart-drawer » (tiroir Eurus, remplacé par fv-panier) n'est plus demandé
  function sections() {
    var h = store("xCartHelper");
    if (!h || !h.getSectionsToRender) return [];
    try { return h.getSectionsToRender().map(function (x) { return x.id; }).filter(function (id) { return id !== "cart-drawer"; }); } catch (e) { return []; }
  }
  function rafraichir(res) {
    var h = store("xCartHelper");
    if (h && res && res.sections && h.reRenderSections) { try { h.reRenderSections(res.sections); } catch (e) { /* compteur non rafraîchi */ } }
  }
  function requete(chemin, corps, erreur) {
    return fetch(RACINE + chemin, { method: corps ? "POST" : "GET", credentials: "same-origin", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: corps ? JSON.stringify(corps) : undefined })
      .then(function (r) {
        return r.json().catch(function () { return {}; }).then(function (j) { if (!r.ok) throw new Error(j.description || j.message || erreur || DEFAUT); return j; });
      });
  }
  function emettre(panier, source, chemin) {
    try { document.dispatchEvent(new CustomEvent(EVENEMENT, { detail: { panier: panier, source: source || "", chemin: chemin } })); } catch (e) { /* navigateur sans CustomEvent */ }
  }

  // écriture mise en file : opts = { source, erreur (message par défaut), sections (false = ne pas demander les sections Eurus) }
  function ecrire(chemin, corps, opts) {
    opts = opts || {};
    corps = corps || {};
    if (!corps.sections && opts.sections !== false) { var s = sections(); if (s.length) corps.sections = s; }
    var tache = file.then(function () {
      return requete(chemin, corps, opts.erreur).then(function (j) {
        rafraichir(j);
        if (chemin.indexOf("cart/add") !== 0) return j;
        // cart/add.js ne renvoie que les lignes ajoutées : le panier complet est relu ici, avant l'écriture suivante (un essai de plus si besoin)
        return requete("cart.js", null, opts.erreur).catch(function () { return requete("cart.js", null, opts.erreur); });
      }).then(function (p) { emettre(p, opts.source, chemin); return p; });
    });
    file = tache.catch(function () { /* un échec n'arrête pas la file */ });
    return tache;
  }
  // lecture : attend les écritures déjà en file, pour lire l'état qui en résulte
  function lire(erreur) { return file.then(function () { return requete("cart.js", null, erreur); }); }

  window.FVCart = {
    evenement: EVENEMENT,
    ecrire: ecrire,
    lire: lire,
    add: function (corps, opts) { return ecrire("cart/add.js", corps, opts); },
    change: function (corps, opts) { return ecrire("cart/change.js", corps, opts); },
    update: function (corps, opts) { return ecrire("cart/update.js", corps, opts); },
    clear: function (opts) { return ecrire("cart/clear.js", {}, opts); }
  };
})();
